import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface HolderTypeProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const holderTypes: ItemVM[] = [
  {
    id: '0',
    value: 'Tutti',
  },
  {
    id: '1',
    value: 'Solo residenti in Italia',
  },
  {
    id: '2',
    value: 'Solo iscritti AIRE',
  },
];

const HolderTypeListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: HolderTypeProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="holder-type-label">
        Tipologia Intestatario
      </InputLabel>
      <PmiSelect
        labelId="holder-type-label"
        id="holder-type"
        name="holder-type"
        value={value}
        label="Tipologia Intestatario"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {holderTypes.map((mode: ItemVM) => (
          <MenuItem key={mode.id} value={mode.id}>
            {mode.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

HolderTypeListComponent.displayName = 'List release modes component';

const HolderTypeList = memo(HolderTypeListComponent);

export default HolderTypeList as typeof HolderTypeListComponent;
